$(function(){
  $('.header-search-submit').on('click', function() {
    var that = $(this),
    href = that.data('href');
    searchInput = that.parent().find($('.header-search-input')),
    search = searchInput.val().trim();

    if (search.length < 3) {
      searchInput.addClass('parsley-error');

      return;
    }
    else {
      searchInput.removeClass('parsley-error'); 
    }

    window.location.href = href + '?keyword=' + search;
  });

  $('.header-search-input').on('keypress', function(e) {
    if(e.which == 13) {
      $(this).parent().find($('.header-search-submit')).trigger('click');
    }
  }); 
});